import constants from '../../common/constants/CommonConstants';
import { STAT_BAR_SCOPES } from '../../common/constants/StatBarConstants';
import {
  fetchStatBarConfig,
  saveStatBarConfig,
} from '../routines/statBarRoutines';

const initial = {
  config: [],
  isLoading: false,
};

const initialState = {
  [`${constants.ORGANIZATION_LEVEL}_${STAT_BAR_SCOPES.ENTITY_LIST}`]: {
    ...initial,
  },
  [`${constants.ACCOUNT_LEVEL}_${STAT_BAR_SCOPES.ENTITY_LIST}`]: { ...initial },
  [`${constants.CONTACT_LEVEL}_${STAT_BAR_SCOPES.ENTITY_LIST}`]: { ...initial },
  [`${constants.PIPELINE_LEVEL}_${STAT_BAR_SCOPES.ENTITY_LIST}`]: {
    ...initial,
  },
  [`${constants.ORGANIZATION_LEVEL}_${STAT_BAR_SCOPES.ENTITY_360}`]: {
    ...initial,
  },
  [`${constants.ACCOUNT_LEVEL}_${STAT_BAR_SCOPES.ENTITY_360}`]: { ...initial },
  [`${constants.CONTACT_LEVEL}_${STAT_BAR_SCOPES.ENTITY_360}`]: { ...initial },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case fetchStatBarConfig.TRIGGER:
    case saveStatBarConfig.TRIGGER: {
      const { level, scope } = action.payload;

      return {
        ...state,
        [`${level}_${scope}`]: {
          ...state[level],
          isLoading: true,
        },
      };
    }
    case fetchStatBarConfig.SUCCESS:
    case saveStatBarConfig.SUCCESS: {
      const { level, scope, config } = action.payload;

      return {
        ...state,
        [`${level}_${scope}`]: {
          config,
          isLoading: false,
        },
      };
    }
    default:
      return state;
  }
};
